(() => {
  if (window.drbProductDetailsModalReady) return;
  window.drbProductDetailsModalReady = true;

  const modalOpenClass = 'drb-product-modal-open';
  let activeOpener = null;

  const getEventElement = (event) => {
    if (event.target instanceof Element) return event.target;
    return event.target?.parentElement || null;
  };

  const closeModal = (modal) => {
    if (!modal) return;

    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove(modalOpenClass);

    if (activeOpener instanceof HTMLElement) {
      activeOpener.focus();
    }

    activeOpener = null;
  };

  const openModal = (opener) => {
    const modalId = opener.getAttribute('data-drb-modal-open');
    const modal = modalId ? document.getElementById(modalId) : null;

    if (!modal) return;

    activeOpener = opener;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add(modalOpenClass);
    modal.querySelector('[role="dialog"]')?.focus();
  };

  document.addEventListener('click', (event) => {
    const eventElement = getEventElement(event);
    if (!eventElement) return;

    const opener = eventElement.closest('[data-drb-modal-open]');
    if (opener) {
      event.preventDefault();
      openModal(opener);
      return;
    }

    const closer = eventElement.closest('[data-drb-modal-close]');
    if (closer) {
      closeModal(closer.closest('[data-drb-product-modal]'));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeModal(document.querySelector('[data-drb-product-modal]:not([hidden])'));
  });
})();
